import { ReactElement } from 'react';
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  styled,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { IQa, readQas } from '.';
import { isEmpty } from 'rambda';
import { map } from 'fp-ts/Array';
import { flow } from 'fp-ts/lib/function';
import { IApiCallStatus } from '../common';

export const QAList = ({
  qaApiStatus,
  items,
}: {
  qaApiStatus: IApiCallStatus;
  items: IQa[];
}) => {
  return qaApiStatus === false ? (
    <Typography style={{ paddingLeft: '1.6rem' }}>
      Failed to get FAQs.
    </Typography>
  ) : isEmpty(items) ? (
    <Typography style={{ paddingLeft: '1.6rem' }}>FAQs are empty.</Typography>
  ) : (
    <Wrapper>
      {flow(
        readQas(items),
        map<IQa[], ReactElement>(qas => (
          <QASection
            section={qas[0].sectionName}
            items={qas}
            key={qas[0].sectionName}
          />
        ))
      )(items)}
    </Wrapper>
  );
};

const QASection = ({ section, items }: { section: string; items: IQa[] }) => {
  return (
    <SectionWrapper>
      <Typography
        variant="h1"
        style={{ fontWeight: 400, paddingLeft: '1.6rem' }}>
        {section}
      </Typography>
      {map<IQa, ReactElement>(qa => (
        <Accordion key={qa.id}>
          <AccordionSummary
            expandIcon={
              <FontAwesomeIcon icon={faChevronDown} size="1x" fixedWidth />
            }
            aria-controls="panel1a-content"
            id="panel1a-header">
            <Typography variant="h5">{qa.question}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              // component="article"
              dangerouslySetInnerHTML={{ __html: qa.answer }}
            />
          </AccordionDetails>
        </Accordion>
      ))(items)}
    </SectionWrapper>
  );
};

const Wrapper = styled('article')(({ theme }) => ({
  '& > * + *': {
    marginTop: '2em',
  },
}));

const SectionWrapper = styled('article')(({ theme }) => ({}));

// const x = [
//   {
//     id: 0,
//     question: 'test question 1',
//     answer: 'test answer 1',
//     application: 'csos',
//     sectionNumber: 1,
//     sectionName: 'S1',
//   },
//   {
//     id: 1,
//     question: 'test question 10',
//     answer: 'test answer 10',
//     application: 'csos',
//     sectionNumber: 1,
//     sectionName: 'S1',
//   },
//   {
//     id: 2,
//     question: 'test question 2',
//     answer: 'test answer 2',
//     application: 'csos',
//     sectionNumber: 2,
//     sectionName: 'S2',
//   },
//   {
//     id: 3,
//     question: 'test question 20',
//     answer: 'test answer 20',
//     application: 'csos',
//     sectionNumber: 2,
//     sectionName: 'S2',
//   },
//   {
//     id: 4,
//     question: 'test question 3',
//     answer: 'test answer 3',
//     application: 'csos',
//     sectionNumber: 3,
//     sectionName: 'S3',
//   },
//   {
//     id: 5,
//     question: 'test question 30',
//     answer: 'test answer 30',
//     application: 'csos',
//     sectionNumber: 3,
//     sectionName: 'S3',
//   },
// ];
